import type { PostTripType } from '@orbit/api-types'
import { toCompact } from '@lib/datetime'
import { CreateTripDraft, tripName } from './draft'

/**
 * The create request the flow produces. Destinations go up in visit order with
 * no indices — the server tiles them from day 0 and derives the trip's
 * dayCount (ADR 0007). Skipped steps are omitted, not sent empty.
 */
export const toPostTripPayload = (draft: CreateTripDraft): PostTripType => {
	// The currency is never skipped — the selector always shows a value, so what
	// the user saw is what the server gets.
	const payload: PostTripType = {
		name: tripName(draft).trim(),
		defaultCurrencyCode: draft.currencyCode,
	}

	if (draft.startDate) {
		payload.startDate = toCompact(draft.startDate)
	}

	if (draft.destinations.length > 0) {
		payload.destinations = draft.destinations.map(destination => ({
			location: destination.place.location,
			dayCount: destination.dayCount,
		}))
	}

	return payload
}
